import React, { useState } from 'react';
import { useStripeAlert } from './stripeStatus';
import { WarnMark, needsSentence, DemoTag } from './StripeStatusCard';
import './StripeStatus.css';

const KEY = 'beu-stripe-alert-collapsed';

/**
 * Router-level persistent alert. Shows on every app page for an owner or
 * self-employed stylist while Stripe needs something or has paused the
 * account. It never goes away until the account is right; "Later" only
 * shrinks it to a chip for this session.
 */
export default function StripeAlertHost() {
  const { active, status, fix } = useStripeAlert();
  const [collapsed, setCollapsed] = useState(() => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } });
  if (!active) return null;
  const collapse = (v) => { setCollapsed(v); try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) { /* ignore */ } };
  const paused = status.key === 'restricted';

  if (collapsed) {
    return (
      <button type="button" className={`ss-bar-chip is-${status.tone}`} onClick={() => collapse(false)} aria-label="Stripe needs your attention. Show details">
        <WarnMark /> <span>{paused ? 'Stripe account paused' : 'Stripe needs attention'}</span>
      </button>
    );
  }

  return (
    <div className={`ss-bar is-${status.tone}`} role="alert">
      <span className="ss-bar-icon" aria-hidden="true"><WarnMark /></span>
      <div className="ss-bar-text">
        <b>{paused ? 'Your Stripe account is paused' : 'Your Stripe account needs attention'}</b>
        <DemoTag demo={status.demo} />
        <span>{paused ? 'You cannot take payments or withdraw until this is sorted.' : `You may be unable to take payments or withdraw until this is fixed. ${needsSentence(status)}`}</span>
      </div>
      <div className="ss-bar-actions">
        {paused
          ? <a className="ss-cta" href="mailto:info@beuapp.com?subject=Stripe%20account%20paused">Contact support</a>
          : <button type="button" className="ss-cta" onClick={fix}>Fix now</button>}
        <button type="button" className="ss-bar-later" onClick={() => collapse(true)}>Later</button>
      </div>
    </div>
  );
}
